function remove(obj, list) {
    const i = list.indexOf(obj);
    list.splice(i, 1);
}

export { remove };
//# sourceMappingURL=remove.js.map
